var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("badge badge-pill badge-" + (_vm.getColor(_vm.env)))},[_vm._v(_vm._s(_vm.env)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }